<div style="display:flex; align-items: center; flex-direction: column; margin-bottom: 30px;">
    <div class="headlines">Reverse Complement Conversion</div>
    <form [formGroup]="ccsForm" (ngSubmit)="getDrugInfo()">
        <div class="form-group">
            <div class="textarea-div">
                <div style="display:flex; align-items: center;">
                    <div style="font-weight: bold;">Enter your Sequence for conversion.</div>
                    <mat-icon
                        matTooltip="Enter your Sequence for conversion in the format 'ACTGctga'. Allowed character are ['A', 'T', 'C', 'G', 'N'] and their lower case representations. Every other letter is translated into '?'. For multiple conversion separate your inputs with a comma. E.g. 'ACTGctga,ctgaACTG' or click 'Load Example' to get a basic example."
                        matTooltipPosition="right" style="transform: scale(0.8);">help</mat-icon>
                </div>
                <textarea class="form-control" id="inputName" formControlName="inputName"
                    placeholder="Enter your Sequence for conversion in the format 'ACTGctga'. Allowed character are ['A|a|T|t|C|c|G|g|N|n] otherwise a '?' will replace every other letter."></textarea>
            </div>
            <div>
                <div>
                    <span>Conversion Type</span>
                    <div>
                        <div>
                            <input type="radio" id="reverse_complement" name="conversion_type"
                                value="reverse_complement" formControlName="conversion_type" />
                            <label for="reverse_complement">Reverse Complement</label>
                        </div>
                        <div>
                            <input type="radio" id="complement" name="conversion_type" value="complement"
                                formControlName="conversion_type" />
                            <label for="complement">Complement</label>
                        </div>
                        <div>
                            <input type="radio" id="reverse" name="conversion_type" value="reverse"
                                formControlName="conversion_type" />
                            <label for="reverse">Reverse</label>
                        </div>

                    </div>
                </div>
                <div>
                    <button type="button" class="btn btn-secondary" matTooltip="Info about the action"
                        matTooltipPosition="right" (click)="getExampleData()">Load Example</button><br>
                    <button type="submit" class="btn btn-primary" [disabled]="!ccsForm.valid">Submit</button>
                </div>
            </div>
        </div>
    </form>
</div>

<div *ngIf="complete_request!=''">
    <app-terminal-view [terminal_string]="complete_request"></app-terminal-view>
</div>

<div class="card-grid" *ngIf="reqObj != null">
    <div class="card" *ngFor="let element of reqObj.data">
        <div class="card-header">
            <h2>{{element.name}}</h2>
        </div>
        <div class="content" *ngIf="element['response']==200">
            <span style="font-weight: bold;">Response Sequence:</span><br>
            <div style="margin: 10px 0px 10px;font-family: monospace; font-weight: 200;max-width:250px;word-wrap:break-word;">{{element['rev_comp']}}</div>
        </div>
        <ul *ngIf="element['response']==400">
            <li style="color:red;">Error: {{element['error']}}</li>
        </ul>
    </div>
</div>